<template>
<div v-if="data" class="classification-box">
	<span v-for="(item, index) in data" :class="actived === index ? 'active' : ''" @click="subTabList(index)">{{ item }}</span>
</div>
</template>
<script>
export default {
  props: ['data'],
  data() {
    return {
      actived: 0
    }
  },
  methods: {
    subTabList(index) {
      this.actived = index
      this.$emit('on-item-click', index)
    }
  }
}
</script>
<style lang="less">
@import (reference) url(../../project.less);
.classification-box{
	background-color: #fff;
	padding:.66rem;
	border-bottom: 1px solid #e6e6e6;
	padding-top: 0.86rem;
	span{
		margin-left: -0.2rem;
		margin-right: -0.2rem;
		font-size: 0.8rem;
		color: @content;
		padding: 0 0.63rem;
		font: 0.8rem/1.15rem @fontStack;
	}
	span.active{
		color: @primary;
	}
}
</style>
